export default __webpack_public_path__ + "static/media/mindmap_sdpm.82b99ae0.png";